"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _Overlay = _interopRequireDefault(require("ol/Overlay"));

var _Draw = _interopRequireDefault(require("ol/interaction/Draw"));

var _Style = _interopRequireDefault(require("ol/style/Style"));

var _Fill = _interopRequireDefault(require("ol/style/Fill"));

var _Circle = _interopRequireDefault(require("ol/style/Circle"));

var _Vector = _interopRequireDefault(require("ol/source/Vector"));

require("./interactions.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var defaultStyle = new _Style.default({
  image: new _Circle.default({
    radius: 1,
    fill: new _Fill.default({
      color: '#ffcc33'
    })
  })
});

var useGetPointGeomInteraction = function useGetPointGeomInteraction(map) {
  var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Select Point or &lt;esc&gt; to Cancel';
  var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStyle;

  /**
   * The ol.geometry to be shown during the operation and
   * to be returned to caller.
   */
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      geometry = _useState2[0],
      setGeometry = _useState2[1];

  var drawStartHandler = (0, _react.useCallback)(function (evt) {
    if (evt.feature && evt.feature.getGeometry() !== geometry) {
      setGeometry(evt.feature.getGeometry());
    }
  }, [geometry]);
  var drawEndHandler = (0, _react.useCallback)(function () {
    setIsRunning(false);
  }, []);
  var drawAbortHandler = (0, _react.useCallback)(function () {//console.log('drawAbortHandler');
  }, []);
  /**
   * Method to create Drawing Interaction
   * The interaction will start once it is added
   * to the map. Once the interaction is started,
   * a temporary feature will be shown
   * 
   * @param {} map 
   * @param {*} source 
   */

  var createInteraction = (0, _react.useCallback)(function (map, source) {
    var newInteraction = new _Draw.default({
      source: source,
      type: 'Point',
      style: style
    }); //register handler for 'drawend' event in the interaction

    newInteraction.on('drawend', drawEndHandler); //register handler for 'drawstart' handler

    newInteraction.on('drawstart', drawStartHandler); //register handler for 'drawabort' handler

    newInteraction.on('drawabort', drawAbortHandler);
    newInteraction.setActive(false); //map.addInteraction(newInteraction);

    return newInteraction;
  }, [drawEndHandler, drawStartHandler, drawAbortHandler, style]);
  /**
   * The Interaction created initially
   * @type {ol.interaction.Draw}
   */

  var interaction = (0, _react.useState)(createInteraction(map, new _Vector.default()))[0];
  /**
  * State to indicate if the interaction is running
  */

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isRunning = _useState4[0],
      setIsRunning = _useState4[1];
  /**
   * Method to create the tooltip.
   * 
   */


  var createTooltip = (0, _react.useCallback)(function () {
    var tooltipEl = document.createElement('div');
    tooltipEl.className = 'tooltip-hidden'; //create overlay tooltip

    var tooltip = new _Overlay.default({
      element: tooltipEl,
      offset: [15, 0],
      positioning: 'center-left'
    });
    return tooltip;
  }, []);
  /**
   * Overlay to show the tooltip messages.
   *  @type {ol.Overlay}
   */
  //const [tooltip, setTooltip] = useState(createTooltip(map));

  var tooltip = (0, _react.useState)(createTooltip())[0];
  /**
   * Handler to handle the event 'mouseout' for the 
   * ol.Viewport. This event is fired once the mouse
   * is outside the viewport area.
   * This method will hide the tooltip once the mouse
   * is outside the viewport area.
   */

  var mouseOutHandler = (0, _react.useCallback)(function () {
    if (tooltip && tooltip.getElement()) {
      tooltip.getElement().innerHTML = "";
      tooltip.getElement().className = 'tooltip-hidden';
    }
  }, [tooltip]);
  /**
   * Handler to handle the event 'pointermove' fired
   * by ol.Map.
   * Triggered when a pointer is moved. Note that on touch devices 
   * this is triggered when the map is panned, so is not the same as 
   * mousemove.
   * This handler will reposition the tooltip in the current mouse
   * position
   */

  var pointerMoveHandler = (0, _react.useCallback)(function (evt) {
    if (evt.dragging) {
      return;
    }

    if (tooltip && tooltip.getElement()) {
      tooltip.getElement().innerHTML = msg;
      tooltip.getElement().className = 'tooltip';
    }

    if (tooltip) tooltip.setPosition(evt.coordinate);
  }, [tooltip, msg]);
  /**
   * Callback to start the interaction
   */

  var start = (0, _react.useCallback)(function () {
    setIsRunning(true);
  }, []);
  /**
   * Callback to stop the interaction
   */

  var stop = (0, _react.useCallback)(function () {
    setIsRunning(false);
  }, []);
  /**
   * Event handler to cancel the interaction 
   * if the user press the <esc> key
   */

  var escKeyHandler = (0, _react.useCallback)(function (evt) {
    if (evt.keyCode === 27) {
      stop();
    }
  }, [stop]);
  var clear = (0, _react.useCallback)(function () {
    setGeometry(null);
  }, []);
  var cleanup = (0, _react.useCallback)(function () {
    document.removeEventListener('keydown', escKeyHandler);
    interaction.setActive(false);
    map.removeOverlay(tooltip);
    map.getViewport().removeEventListener('mouseout', mouseOutHandler);
    map.un('pointermove', pointerMoveHandler);
    mouseOutHandler();
  }, [interaction, map, tooltip, pointerMoveHandler, mouseOutHandler, escKeyHandler]);
  /**
   * Effect to start/stop the interaction based
   * on the 'isRunning' state
   */

  (0, _react.useEffect)(function () {
    if (isRunning) {
      document.addEventListener('keydown', escKeyHandler);
      interaction.setActive(true);
      map.addOverlay(tooltip);
      map.getViewport().addEventListener('mouseout', mouseOutHandler);
      map.on('pointermove', pointerMoveHandler);
    } else {
      cleanup();
    }

    return function () {
      cleanup();
    };
  }, [isRunning, interaction, map, tooltip, cleanup, pointerMoveHandler, mouseOutHandler, escKeyHandler]);
  /**
   * Effect to add/remove the interaction from the map
   */

  (0, _react.useEffect)(function () {
    map.addInteraction(interaction);
    return function () {
      map.removeInteraction(interaction);
    };
  }, [createInteraction, interaction, map]);
  return {
    start: start,
    stop: stop,
    clear: clear,
    geometry: geometry,
    isRunning: isRunning
  };
};

var _default = useGetPointGeomInteraction;
exports.default = _default;